/* eslint no-unused-vars:0 */
import React, { Component } from 'react'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, info) {
    this.setState({ error })
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ marginLeft: '15px', border: '1px solid red' }}>
          <h3>{this.props.item.layoutVariant} has an exception</h3>
          <pre>{this.state.error.stack}</pre>
        </div>
      )
    }
    return this.props.children
  }
}
